import React from "react";
import "../Components/Styles/TermsConditions.css";
import { Helmet } from "react-helmet-async";

const TermsConditions = () => {
  return (
      <>

         <Helmet>
           <link rel="canonical" href="https://www.hcfinvest.com/termsConditions" />
         </Helmet>

              <div className="container mt-5">
      <h1 className="heading">Terms & Conditions</h1>
      <br />

      <h4 className="head">General Terms</h4>
      <p>
        By accessing and placing an order with, you confirm that you are in
        agreement with and bound by the terms of service contained in the Terms
        & Conditions outlined below. These terms apply to the entire website and
        any email or other type of communication between you and
      </p>

      <p>
        Under no circumstances shall team be liable for any direct, indirect,
        special, incidental or consequential damages, including, but not limited
        to, loss of data or profit, arising out of the use, or the inability to
        use, the materials on this site, even if team or an authorized
        representative has been advised of the possibility of such damages. If
        your use of materials from this site results in the need for servicing,
        repair or correction of equipment or data, you assume any costs thereof.
      </p>

      <p>
        will not be responsible for any outcome that may occur during the course
        of usage of our resources. We reserve the rights to change prices and
        revise the resource usage policy at any moment.
      </p>

      <h4 className="head">License</h4>
      <p>
        <strong>
          Heddge Capitals Wealth Management LLC, operating under the brand name
          HC Finvest
        </strong>{" "}
        grants you a revocable, non-exclusive, non-transferable, limited license
        to download, install and use our service strictly in accordance with the
        terms of this Agreement.
      </p>

      <p>
        These Terms & Conditions are a contract between you and HC Finvest
        (referred to in these Terms & Conditions as "HC Finvest" "us", "We" or
        "our"), the provider of the HC Finvest website and the services
        accessible from the HC Finvest website (which are collectively referred
        to in these Terms & Conditions as the "HC Finvest Service") You are
        agreeing to be bound by these Terms & Conditions. If you do not agree to
        these Terms & Conditions, please do not use the Service. In these Terms
        & Conditions, "you" refers both to you as an individual and to the
        entity you represent. If you violate any of these Terms & Conditions, we
        reserve the right to cancel your account or block access to your account
        without notice.
      </p>

      <h4 className="head">Definitions and key terms</h4>
      <p>For this Terms & Conditions :-</p>

      <ul className="b">
        <li>
          <p>
            <b>Cookie :-</b> small amount of data generated by a website and
            saved by your web browser. It is used to identify your browser,
            provide analytics, remember information about you such as your
            language preference or login information.
          </p>
        </li>

        <li>
          <p>
            <b>Country :-</b> where HC Finvest or the owners/founders of HC
            Finvest are based, in this case is India.
          </p>
        </li>

        <li>
          <p>
            <b>Customer :-</b> refers to the company, organization or person
            that signs up to use the HC Finvest Service to manage the
            relationships with your consumers or service users.
          </p>
        </li>

        <li>
          <p>
            <b>Device :-</b> any internet connected device such as a phone,
            tablet, computer or any other device that can be used to visit HC
            Finvest and use the services.
          </p>
        </li>

        <li>
          <p>
            <b>IP address :-</b> Every device connected to the Internet is
            assigned a number known as an Internet protocol (IP) address. These
            numbers are usually assigned in geographic blocks. An IP address can
            often be used to identify the location from which a device is
            connecting to the Internet.
          </p>
        </li>

        <li>
          <p>
            <b>Personnel :-</b> refers to those individuals who are employed by
            HC Finvest or are under contract to perform a service on behalf of
            one of the parties.
          </p>
        </li>

        <li>
          <p>
            <b>Personal Data :-</b> any information that directly, indirectly,
            or in connection with other information-including a personal
            identification number-allows for the identification or
            identifiability of a natural person.
          </p>
        </li>

        <li>
          <p>
            <b>Service :-</b> refers to the service provided by HC Finvest as
            described in the relative terms (if available) and on this platform.
          </p>
        </li>

        <li>
          <p>
            <b>Third-party service :-</b> refers to advertisers, contest
            sponsors, promotional and marketing partners, and others who provide
            our content or whose products or services we think may interest you.
          </p>
        </li>

        <li>
          <p>
            <b>Website :-</b> HC Finvest site, which can be accessed via this
            URL: <b>www.hcfinvest.com</b>
          </p>
        </li>

        <li>
          <p>
            You are a person or entity that is registered with HC Finvest to use
            the Services.
          </p>
        </li>
      </ul>

      <h5>
        <b>You agree not to, and you will not permit others to :-</b>
      </h5>

      <ul className="b">
        <li>
          <p>
            License, sell, rent, lease, assign, distribute, transmit, host,
            outsource, disclose or otherwise commercially exploit the service or
            make the platform available to any third party.
          </p>
        </li>

        <li>
          <p>
            Modify, make derivative works of, disassemble, decrypt, reverse
            compile or reverse engineer any part of the service.
          </p>
        </li>

        <li>
          <p>
            Remove, alter or obscure any proprietary notice (including any
            notice of copyright or trademark) of or its affiliates, partners,
            suppliers or the licensors of the service.
          </p>
        </li>
      </ul>

      <h4 className="head">Payment</h4>

      <p>
        If you pay for any of our one-time payment plans, you agree to pay all
        fees or charges to your account for the Service in accordance with the
        fees, charges and billing terms in effect at the time that each fee or
        charge is due and payable. Your Payment Provider agreement governs your
        use of the designated credit card account, and you must refer to that
        agreement and not these Terms to determine your right and liabilities
        with respect to your Payment Provider. By providing us with your credit
        card number and associated payment information, you agree that we are
        authorized to verify information immediately, and subsequently invoice
        your account for all fees and charges due and payable to us hereunder
        and that no additional notice or consent is required. You agree to
        immediately notify us of any change in your billing address or the
        credit card used for payment hereunder. We reserve the right at any time
        to change its prices and billing methods, either immediately upon
        posting on our Site or by e-mail delivery to your organization's
        administrator(s). Any attorney fees, court costs, or other costs
        incurred in collection of delinquent undisputed amounts shall be the
        responsibility of and paid for by you. No contract will exist between
        you and us for the Service until we accept your order.
      </p>
    </div>
      </>
  );
};

export default TermsConditions;
